import { useModel, useRoute } from "@bcm-dev/bcms-vite";
import { useMultiPay } from "compid/workflows/MultiPay";
import { Bill, Payment } from "model/";

import ButtonContainer from "compid/shared/containers/ButtonContainer";
import BillerView from "compid/shared/views/BillerView";
import BillerPaymentView from "compid/shared/views/BillerView/components/views/BillerPaymentView";
import UIButton from "compid/ui/UIButton";
import UICheckbox from 'compid/ui/UICheckbox';
import { SVGAsset } from "res";

export default function AlphaBillerView(props) {
    const { payments } = useModel();
    const { toggleAdd, state, submit } = useMultiPay();
    const navigate = useRoute();
   
    const addedBillerViewIDs = [];
    const bills =  Bill.initAll().reduce((result, bill) => {
        const lastPayment = Payment.getLastPaymentByBillerID(bill.biller.id, payments)||{"status":"none"};

        const isIncluded = state.includes(bill.id);
        const shouldDisable = state.length > 0;

        const disabledClass = shouldDisable ? "disabled-gray" : "";
        const billerIsAdded = bill.biller.addType !== "quick_add" && bill.biller.addType !== "verification_add";

        const onClick = evt => !shouldDisable
            ? navigate(`/makeAPayment/${ bill.id }`)
            : undefined;

        const billerValidStatus = bill.status.toLowerCase() !== "due";
       
        const billerID = bill.biller.id;
        // A biller can have multiple bills.
        // If any of those bills are "due", do not show this biller here.
        const billerHasDueBills = Bill.initAll().filter(bill => {
                     if( bill.biller.id === billerID){
                        if(bill.status.toLowerCase() === "due"){
                                if (bill.reminder){
                                    return  bill.reminder.daysToRemindMeInAdvanced > bill.reminder.dueDate.diff()
                                }
                                return true
                        }
                     }  
        return false;
                    }).length > 0;
        const didAddBillerView = addedBillerViewIDs.indexOf(billerID) > -1;
        // Keep track of added "Billers" so that we don't show them twice.
        if(!didAddBillerView) {
            addedBillerViewIDs.push(bill.biller.id);
        }

        const showBillerView = billerValidStatus && lastPayment && billerIsAdded && !billerHasDueBills && !didAddBillerView;
        const group = props.group;
        const showPayIcon = bill.biller.paymentType === "instantPayment" || bill.biller.paymentType === "withinMinutes";
      
        const billerInGroup = (biller)=>{
           
            if (group === "default"){
                return biller.billerGroup === undefined;
            }else{
               if( biller.billerGroup !== undefined){
                return group !== undefined ? biller.billerGroup.id === group:true; 
               }else{
                return group == undefined ;
               }
                
            }
               
        } 
        if(showBillerView && billerInGroup(bill.biller)) {
            result.push(
                <BillerView
                    key={ "biller_" + bill.biller.id + "_bill_" + bill.id }
                    biller={ bill.biller }
                    className={ isIncluded ? "selected-biller-view paid-upcoming-biller-view" : "paid-upcoming-biller-view" }
                    checkbox={
                         <UICheckbox value={ isIncluded } dataPoint={`My_Billers_Biller_Checkbox_${ bill.biller.id }`} onChange={ value => toggleAdd(value, bill.id) } /> 
                        }
                    showPaymentInfo={ !(lastPayment.status.toLowerCase() === "canceled") }
                    //dataPoint={ `Pay_Bills_Biller_${ bill.biller.id }` }
                    dataPoint={`My_Billers_Biller`}
                    paymentInfo={
                        lastPayment.status === "none"?null:<BillerPaymentView
                            lastPayment={ lastPayment.status === "none" }
                            amount={ lastPayment.amount }
                            status={ lastPayment.status }
                            date={ lastPayment.formatDate }
                            payment={ lastPayment }
                            dataPoint={ `My_Billers_Payment` }
                            description={<>Last<span className="show-on-desktop payment">Payment</span><span className="show-on-mobile payment">pmt</span></>} />
                    }
                    buttons={
                        <>
                            { !isIncluded &&
                                <ButtonContainer className="set-width">
                                    <UIButton className={ `secondary-button ${ disabledClass }` }
                                        onClick={ onClick } dataPoint={ `My_Billers_Button_Biller_${ bill.biller.id }` }>Pay{ showPayIcon && <SVGAsset id="ZapIcon" className="zap-icon" /> }</UIButton>
                                </ButtonContainer> }

                            { isIncluded && 
                                <ButtonContainer className="set-width">
                                    <UIButton 
                                        className="primary-button multipay-btn"
                                        dataPoint={ `My_Billers_Button_Biller_${ bill.biller.id }` } 
                                        onClick={ submit }>Pay { state.length } biller{ state.length > 1 ? "s" : "" }</UIButton>
                                </ButtonContainer> }
                        </>
                    }
                    upsell={ props.getUpSale(bill) } />
            );
        }

        return result;
    }, []  ).sort((a,b)=>{
        if(a.props.biller.name.toLowerCase() > b.props.biller.name.toLowerCase())
            return 1;
        if(a.props.biller.name.toLowerCase() <b.props.biller.name.toLowerCase())
            return -1;
        return 0;
    });

 
   
    return <> { bills } </>;
}